import { render, staticRenderFns } from "./DropdownAccount.vue?vue&type=template&id=5169ddd5&scoped=true&"
import script from "./DropdownAccount.vue?vue&type=script&lang=ts&"
export * from "./DropdownAccount.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownAccount.vue?vue&type=style&index=0&id=5169ddd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169ddd5",
  null
  
)

export default component.exports